module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ac-item",
    class: [_vm.isActive ? 'ac-active' : ''],
    on: {
      "click": _vm.toggleActive
    }
  }, [_c('h5', {
    staticClass: "ac-title"
  }, [_c('i', {
    class: _vm.getClasses()
  }), _vm._v(" " + _vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "ac-content",
    class: [_vm.isActive ? 'showed' : 'hidden']
  }, [_c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.categories), function(category) {
    return _c('div', {
      key: category.id,
      staticClass: "list-group-item"
    }, [_c('router-link', {
      staticClass: "parent-link",
      attrs: {
        "to": {
          name: 'home',
          params: {
            type: _vm.slug,
            slug: category.slug
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.goToDataView($event)
        }
      }
    }, [_vm._v("\n          " + _vm._s(category.name) + "\n          "), _c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(category.count))])]), _vm._v(" "), (category.childrens) ? _c('div', {
      staticClass: "childrens-area"
    }, _vm._l((category.childrens), function(child) {
      return _c('router-link', {
        key: child.id,
        staticClass: "children-link",
        attrs: {
          "to": {
            name: 'home',
            params: {
              type: _vm.slug,
              slug: child.slug
            }
          }
        },
        nativeOn: {
          "click": function($event) {
            _vm.goToDataView($event)
          }
        }
      }, [_vm._v("\n            " + _vm._s(child.name) + "\n            "), _c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(child.count))])])
    })) : _vm._e()], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b24bb2b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavItem.vue
// module id = 59
// module chunks = 1